import { MOBILE_TABS } from '@/data/mockData';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard, ShoppingCart, Package, MapPin, User,
} from 'lucide-react';

const ICON_MAP: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  LayoutDashboard, ShoppingCart, Package, MapPin, User,
};

interface MobileTabBarProps {
  currentPage: string;
  activeChildId?: string;
  onNavigate: (page: string, childId?: string) => void;
}

export function MobileTabBar({ currentPage, activeChildId, onNavigate }: MobileTabBarProps) {
  return (
    <nav className="xl:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-zinc-200 flex z-40 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_12px_rgba(0,0,0,0.04)]">
      {MOBILE_TABS.map((tab) => {
        const Icon = ICON_MAP[tab.icon] || LayoutDashboard;
        const active = currentPage === tab.id && (!tab.childId || activeChildId === tab.childId);
        return (
          <button
            key={tab.id}
            onClick={() => onNavigate(tab.id, tab.childId)}
            aria-current={active ? 'page' : undefined}
            aria-label={tab.childId ? `打开${tab.label}资料` : `打开${tab.label}`}
            className={cn(
              'min-h-14 flex-1 flex flex-col items-center justify-center gap-0.5 py-1.5 transition-colors touch-manipulation',
              active ? 'text-emerald-600' : 'text-zinc-400'
            )}
          >
            <Icon aria-hidden="true" className={cn('w-5 h-5', active && 'scale-110')} style={{ transition: 'transform 0.15s' }} />
            <span className={cn('text-[10px]', active && 'font-semibold')}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
